/**
 * Message Enums
 *
 * Type definitions for message types, subtypes, and initiator types.
 * Based on V1's enums/messages.js
 */

export const MESSAGE_TYPES = {
  TEXT: 'text',
  IMAGE: 'image',
  FILE: 'file',
} as const;

export type MessageType = (typeof MESSAGE_TYPES)[keyof typeof MESSAGE_TYPES];

export const MESSAGE_SUB_TYPES = {
  BUTTON_PROMPT_SELECTED: 'BUTTON_PROMPT_SELECTED',
  CHECKOUT_COMPLETED: 'CHECKOUT_COMPLETED',
  COMPOSITE_MESSAGE: 'COMPOSITE_MESSAGE',
  CREDIT_CARD_REQUEST: 'CREDIT_CARD_REQUEST',
  DATA_DISPLAY: 'DATA_DISPLAY',
  FILE: 'FILE',
  FLEXIBLE_CARD: 'FLEXIBLE_CARD',
  HTML: 'HTML',
  IMAGE: 'IMAGE',
  QUICK_REPLY_REQUEST: 'QUICK_REPLY_REQUEST',
  QUICK_REPLY_RESPONSE: 'QUICK_REPLY_RESPONSE',
  SESSION_END: 'SESSION_END',
  TEXT: 'TEXT',
  URL: 'URL',
} as const;

export type MessageSubType = (typeof MESSAGE_SUB_TYPES)[keyof typeof MESSAGE_SUB_TYPES];

export const PROMPTS_SOURCES = {
  STATIC: 'STATIC',
  AI: 'AI',
} as const;

export type PromptsSource = (typeof PROMPTS_SOURCES)[keyof typeof PROMPTS_SOURCES];

export const INITIATOR_TYPES = {
  AGENT: 'AGENT',
  API: 'API',
  AUTOMATION: 'AUTOMATION',
  CUSTOMER: 'CUSTOMER',
  SYSTEM: 'SYSTEM',
} as const;

export type InitiatorType = (typeof INITIATOR_TYPES)[keyof typeof INITIATOR_TYPES];

export const DATA_DISPLAY_TYPES = {
  ORDER_STATUS: 'ORDER_STATUS',
  PRODUCT_LIST: 'PRODUCT_LIST',
} as const;

export type DataDisplayType = (typeof DATA_DISPLAY_TYPES)[keyof typeof DATA_DISPLAY_TYPES];
